import { FaGamepad, FaBriefcase, FaUsers } from 'react-icons/fa';
import { useLanguage } from '../i18n';

const Services = ({ setActiveSection }) => {
  const { language } = useLanguage();
  const c = language === 'es' ? { title:'Desarrollo con mirada indie', intro:'Ayudamos a convertir ideas jugables en prototipos, arte y producción concreta, con procesos livianos y comunicación directa.', game:'Desarrollo de juegos', gameDesc:'Prototipos, vertical slices y producción de juegos para PC y mobile.', gameItems:['Unity y Godot Engine','Juegos móviles y PC','Prototipado y MVP'], art:'Arte y diseño', artDesc:'Dirección visual, personajes, escenarios, UI y animación para juegos 2D.', artItems:['Pixel art y arte 2D','Diseño de personajes','UI/UX para gameplay','Animación y efectos'], consulting:'Consultoría', consultingDesc:'Feedback honesto para ordenar alcance, diseño, pipeline y prioridades técnicas.', consultingItems:['Revisión de diseño','Plan de producción','Auditorías técnicas'], idea:'¿Tenés una idea de juego?', cta:'Contanos en qué etapa estás y vemos cómo podemos sumar sin inflar el proyecto.', talk:'Hablemos', view:'Ver portafolio' } : { title:'Development with an indie perspective', intro:'We turn playable ideas into prototypes, artwork and real production through lightweight processes and direct communication.', game:'Game development', gameDesc:'Prototypes, vertical slices and game production for PC and mobile.', gameItems:['Unity and Godot Engine','Mobile and PC games','Prototyping and MVPs'], art:'Art and design', artDesc:'Visual direction, characters, environments, UI and animation for 2D games.', artItems:['Pixel art and 2D art','Character design','Gameplay UI/UX','Animation and effects'], consulting:'Consulting', consultingDesc:'Honest feedback to organize scope, design, pipelines and technical priorities.', consultingItems:['Design review','Production planning','Technical audits'], idea:'Have a game idea?', cta:"Tell us where you are in the process and we'll see how we can help without inflating the project.", talk:"Let's talk", view:'View portfolio' };
  return (
    <section id="services" className="section-shell min-h-screen px-4 py-12 sm:py-16 lg:py-20">
      <div className="section-content max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="section-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6">
            {c.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-purple-200 max-w-3xl mx-auto px-4">
            {c.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12 lg:mb-16">
          <div className="modern-panel rounded-xl p-5 sm:p-6 transition-all duration-300 transform hover:-translate-y-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-purple-600/70 rounded-lg mb-4 flex items-center justify-center border border-white/15">
              <FaGamepad className="text-lg sm:text-2xl text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">{c.game}</h3>
            <p className="text-purple-200 mb-3 sm:mb-4 text-sm sm:text-base">
              {c.gameDesc}
            </p>
            <ul className="text-purple-300 space-y-1 sm:space-y-2 text-xs sm:text-sm">
              {c.gameItems.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>

          <div className="modern-panel rounded-xl p-5 sm:p-6 transition-all duration-300 transform hover:-translate-y-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-indigo-600/70 rounded-lg mb-4 flex items-center justify-center border border-white/15">
              <FaBriefcase className="text-lg sm:text-2xl text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">{c.art}</h3>
            <p className="text-purple-200 mb-3 sm:mb-4 text-sm sm:text-base">
              {c.artDesc}
            </p>
            <ul className="text-purple-300 space-y-1 sm:space-y-2 text-xs sm:text-sm">
              {c.artItems.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>

          <div className="modern-panel rounded-xl p-5 sm:p-6 transition-all duration-300 transform hover:-translate-y-1">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-pink-600/70 rounded-lg mb-4 flex items-center justify-center border border-white/15">
              <FaUsers className="text-lg sm:text-2xl text-white" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">{c.consulting}</h3>
            <p className="text-purple-200 mb-3 sm:mb-4 text-sm sm:text-base">
              {c.consultingDesc}
            </p>
            <ul className="text-purple-300 space-y-1 sm:space-y-2 text-xs sm:text-sm">
              {c.consultingItems.map(item => <li key={item}>{item}</li>)}
            </ul>
          </div>
        </div>

        <div className="text-center">
          <div className="modern-panel rounded-xl p-5 sm:p-6 lg:p-8">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">{c.idea}</h3>
            <p className="text-purple-200 mb-4 sm:mb-6 text-sm sm:text-base px-2">
              {c.cta}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <button
                onClick={() => setActiveSection('contact')}
                className="primary-button w-full sm:w-auto px-6 sm:px-8 py-2 sm:py-3 rounded-full font-semibold transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
              >
                {c.talk}
              </button>
              <button
                onClick={() => setActiveSection('portfolio')}
                className="secondary-button w-full sm:w-auto px-6 sm:px-8 py-2 sm:py-3 rounded-full font-semibold transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
              >
                {c.view}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
